export const weeksAmount = '~ 6 Weeks'
export const collectionName = 'Collection'
